import { Model as e } from "../../../../model.js";
class s extends e {
  constructor(t) {
    super(), this.identifierCodeType = t.identifierCodeType, this.progressBarType = t.progressBarType, this.fontFamily = t.fontFamily, this.colors = t.colors, this.texts = t.texts, this.images = t.images;
  }
}
export {
  s as StampProgrammeDesignModel
};
//# sourceMappingURL=stampProgrammeDesign.model.js.map
